import { withInstall } from '@xzx-design/utils'
import _NavBar from './src/nav-bar'

export const NavBar = withInstall(_NavBar)
export default NavBar

export * from './src/nav-bar'
export * from './src/types'
